<template>
  <div>
    <emd-collapse :title="$t('boleto')">
      <template v-slot:icon>
        <label class="emd-checkbox">
          <input
            type="checkbox"
            class="emd-checkbox__input"
            v-model="boletoEnabled"
          />
          <div class="emd-checkbox__area"></div>
        </label>
      </template>
      <template v-slot:subtitle>
        <span class="subtitle">{{ $t('receiveLabel') }}</span>
      </template>
      <template v-slot:content>
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_4_md">
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('daysToExpire') }} <span class="label-optional">({{ $t('days') }})</span></label>
              <div class="eu-flex eu-align-items_center">
                <div class="eu-flex-item">
                  <div class="emd-input-group _icon_left _icon_right">
                    <a class="emd-input-icon__link" @click="subtractQuantity">
                      <i class="uil uil-minus"></i>
                    </a>
                    <input
                      :class="{'_state_error': $v.boletoSettings.due_in.$invalid && showFeedbacks.status && boletoEnabled}"
                      class="emd-input eu-align_center"
                      v-model="boletoSettings.due_in"
                      @input="filterChar"
                    />
                    <a class="emd-input-icon__link" @click="addQuantity">
                      <i class="uil uil-plus"></i>
                    </a>
                  </div>
                  <p class="emd-input-feedback _state_error" v-if="!$v.boletoSettings.due_in.required && showFeedbacks.status && boletoEnabled">
                    {{ $t('hint.required') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <discount class="eu-flex-item eu-basis_12 eu-basis_8_md" v-if="boletoSettings.has_discount" @changeDiscount="changeDiscount"/>
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
            <div class="emd-form-group eu-py_1_md">
              <label class="emd-checkbox">
                <input
                  type="checkbox"
                  class="emd-checkbox__input"
                  v-model="boletoSettings.has_discount"
                />
                <div class="emd-checkbox__area"></div>
                <span class="emd-checkbox__text">
                  {{ $t('discountLabel') }}
                </span>
              </label>
            </div>
          </div>
          <div v-if="boletoSettings.has_discount" class="eu-flex-item eu-basis_12 eu-basis_12_md discount-info">
            {{ $t('discountInfo') }}
          </div>
        </div>

      </template>
      <template v-slot:footer>
        <hr class="emd-divider" />
        <div class="emd-container__footer eu-no-padding eu-align-items_center eu-wrap">
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-align_center eu-no-margin_md eu-pa_3 eu-px_3">
            <a class="boleto-info">
              <i class="uil uil-info-circle"></i> {{ $t('boletoInfo') }}
            </a>
          </div>
        </div>
      </template>
    </emd-collapse>
  </div>
</template>

<script>
import { EmdCollapse } from 'emerald-vue/src/components'
import Discount from '@/components/project/PaymentMethods/Discount.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Boleto',
  components: {
    EmdCollapse,
    Discount
  },
  data () {
    return {
      timeToExpireLabel: `1 ${this.$t('day')}`,
      discountValue: 0,
      discountFormat: null
    }
  },
  computed: {
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    boletoEnabled: {
      get () {
        return this.$store.getters.paymentMethods.boleto_enabled
      },
      set (newValue) {
        this.$store.dispatch('BOLETO_PAYMENT', newValue)
      }
    },
    boletoSettings () {
      return this.$store.getters.paymentLinkData.boleto_settings
    }
  },
  validations: {
    boletoSettings: {
      due_in: {
        required
      }
    }
  },
  methods: {
    filterChar () {
      this.$emit('formIsValid', this.$v.$invalid)
      this.boletoSettings.due_in = this.boletoSettings.due_in.replace(/[^\d]+/g, '')
    },
    onChangeBoleto (value, attribute) {
      this.$store.dispatch('UPDATE_BOLETO_DATA',
        {
          value: value,
          attribute: attribute
        }
      )
    },
    changeDiscount (value) {
      this.$store.dispatch('UPDATE_BOLETO_DATA',
        {
          value: value.discountValue,
          attribute: 'discount'
        }
      )

      this.$store.dispatch('UPDATE_BOLETO_DATA',
        {
          value: value.discountFormat,
          attribute: 'discount_type'
        }
      )
    },
    subtractQuantity () {
      this.$emit('formIsValid', this.$v.$invalid)
      if (this.boletoSettings.due_in > 1) {
        this.boletoSettings.due_in = Number(this.boletoSettings.due_in) - 1
      }
    },
    addQuantity () {
      this.$emit('formIsValid', this.$v.$invalid)
      if (this.boletoSettings.due_in < 30) {
        this.boletoSettings.due_in = Number(this.boletoSettings.due_in) + 1
      }
    }
  }
}
</script>

<style>
.boleto-info {
  color: #72737A;
  font-weight: 700;
  font-size: 12px;
}
.subtitle {
  color: var(--brand--le--secondary-color--base);
  font-weight: 400;
  font-size: 12px;
}
.discount-info {
  color: #72737A;
  padding-top: 4px;
  font-size: 12px;
}
</style>

<i18n>
{
  "pt-BR": {
    "boleto": "Boleto",
    "shipping": "Valor do frete",
    "daysToExpire": "Tempo até vencimento",
    "discountLabel": "Desconto para pagamento no boleto",
    "discountValue": "Valor do desconto",
    "discountFormat": "Formato do desconto",
    "boletoInfo": "Os dias passam a contar a partir do momento que seu cliente gerar o boleto",
    "receiveLabel": "Receba em até 3 dias úteis",
    "days": "em dias",
    "discountInfo": "O desconto será aplicado sobre o valor da compra e não se aplica ao frete.",
    "hint": {
      "required": "Campo de preenchimento obrigatório"
    }
  },
  "en-US": {
    "boleto": "Boleto",
    "shipping": "Shipping value",
    "daysToExpire": "Days to expire",
    "discountLabel": "Boleto payment discount",
    "discountValue": "Discount value",
    "discountFormat": "Discount format",
    "boletoInfo": "The days start counting from the moment your client generates the bill",
    "receiveLabel": "Receive in 3 business days",
    "days": "in days",
    "discountInfo": "The discount will be applied to the purchase price and does not apply to shipping.",
    "hint": {
      "required": "This field is required"
    }
  }
}
</i18n>
